import { Link } from "react-router-dom";
import { useTheme } from "../../theme/ThemeProvider";
import Layout from "../../components/Layout";
import { useSEO } from "../../hooks/useSEO";
import { HOME_ROUTE, PAGE_NOT_FOUND_ROUTE } from "../../routes/constant";

const ErrorPageNotFound = () => {
  const { isDarkMode } = useTheme();

  useSEO(PAGE_NOT_FOUND_ROUTE);

  return (
    <Layout>
      <div
        className={`min-h-[70vh] flex items-center justify-center px-4 py-16 ${
          isDarkMode ? "bg-gray-900" : "bg-gray-50"
        }`}
      >
        <div className="max-w-md mx-auto text-center">
          {/* 404 Number */}
          <div className="mb-8">
            <h1
              className={`text-8xl md:text-9xl font-bold tracking-tight ${
                isDarkMode ? "text-gray-700" : "text-gray-200"
              }`}
            >
              404
            </h1>
            <div
              className={`h-1 w-24 mx-auto mt-4 ${
                isDarkMode ? "bg-green-600" : "bg-green-500"
              }`}
            />
          </div>

          {/* Error Message */}
          <div className="mb-8">
            <h2
              className={`text-2xl md:text-3xl font-semibold mb-3 ${
                isDarkMode ? "text-white" : "text-gray-800"
              }`}
            >
              Page Not Found
            </h2>
            <p
              className={`text-base md:text-lg ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* Helpful Actions */}
          <div className="space-y-4">
            <Link
              to={HOME_ROUTE}
              className={`inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium ${
                isDarkMode
                  ? "bg-green-600 hover:bg-green-700 text-white"
                  : "bg-green-500 hover:bg-green-600 text-white"
              }`}
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ErrorPageNotFound;
